import { FC } from "react";
import { t } from "i18next";
import { useFormContext } from "react-hook-form";

// Services and Interfaces
import { IRecipeForm } from "@/interfaces/recipe/recipe_form";

// Components
import { Box } from "@mui/material";
import TextInput from "@/components/text_input";


const RecipeForm: FC = () => {

    const { control } = useFormContext<IRecipeForm>();

    return (
        <Box display="flex" width={400}>

            <Box display="flex" flexDirection="column" width="100%">
                <TextInput 
                    name="title"
                    control={control}
                    placeHolder={t('inputs.placeholders.recipeName')}
                    maxLength={50}
                    />
            </Box>

        </Box>
    )
}

export default RecipeForm;